import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PlayersPaymentRoutingModule } from './players-payment-routing.module';
import { PlayersPaymentComponent } from './players-payment.component';


@NgModule({
  declarations: [
    PlayersPaymentComponent
  ],
  imports: [
    CommonModule,
    PlayersPaymentRoutingModule,
  ]
})
export class PlayersPaymentModule { }
